import { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import ReactQuill from "react-quill";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";
import { FaStar } from "react-icons/fa6";
import { IoInformationCircle } from "react-icons/io5";
import Tooltip from "./ui/Tooltip";
import pp from "../images/pp.png";
const SwipeFeedback = ({ roundsinfo, isFromACFL }) => {
  const [data, setData] = useState([...roundsinfo]);
  const [shifted, setShifted] = useState(false);

  useEffect(() => {
    if (!shifted && data.length > 0) {
      const newData = [...data];
      newData.shift();
      setData(newData);
      setShifted(true);
    }
  }, [data, shifted]);
  return (
    <div>
      {data.length > 0 ? (
        <div className="">
          <Swiper
            modules={[Navigation, A11y]}
            spaceBetween={10}
            slidesPerView={3}
            navigation
          >
            {data.map((c, i) => (
              <SwiperSlide key={i}>
                <div className="block items-center bg-white border-2 border-slate-300 rounded-xl h-full overflow-y-auto">
                  <div className="w-full flex flex-col">
                    <h2 className="font-semibold mt-1 relative mb-2 p-4 before:block before:bg-[#148EFF] before:w-1 before:content-'' before:absolute before:left-0 before:top-1/2 before:h-[20px] before:mr-4 before:transform before:-translate-y-1/2">
                      Round {c.roundfrom}
                    </h2>
                    <hr className="border-[#E9EBFA] w-full" />

                    {/* Scrollable area */}
                    <div className="flex flex-col gap-2 p-2 overflow-y-auto flex-1">
                      <div className="flex items-start">
                        <img
                          src={pp}
                          alt="Avatar"
                          className="rounded-full w-6 h-6 mr-2 border-2 border-slate-300 mt-1"
                        />
                        <h3 className="text-lg font-semibold mr-2 w-max">
                          {c.functionalmanagername || c.assignedInterviewerName}
                        </h3>
                        <div className="flex items-center gap-2 mt-1">
                          <div className="flex w-fit text-orange-600 text-sm bg-orange-200 px-2 py-0 h-fit items-center justify-center gap-1 rounded-sm">
                            <span>{c.star}</span>
                            <FaStar />
                          </div>
                          {isFromACFL && (
                            <div className="flex w-fit text-blue-600 text-sm bg-blue-100 px-2 py-0 h-fit items-center justify-center gap-1 rounded-sm">
                              <span className='flex w-max'>Total: {
                                ["communicationSkills", "personality", "teamwork", "attitude", "culturalFitment", "businessUnderstanding"]
                                  .reduce((sum, key) => sum + (c[key] || 0), 0)
                              }</span>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="text-sm">
                        <span className="text-slate-500">Date: </span>
                        {c.assigneedate ? c.assigneedate.split("T")[0] : c.createdat.split("T")[0]}
                      </div>

                      {/* Feedback now scrolls if too long */}
                      <div className="text-sm leading-relaxed overflow-y-auto max-h-[150px] pr-2 pb-4">
                        {isFromACFL ? (
                          <div className="mt-1 space-y-2">
                            <div className="grid grid-cols-2 gap-x-4 gap-y-1">
                              {["communicationSkills", "personality", "teamwork", "attitude", "culturalFitment", "businessUnderstanding"].map((key) => {
                                return (
                                  <div key={key} className="flex justify-between text-xs items-center">
                                    <span className="text-gray-600 capitalize flex items-center gap-1">
                                      <span className="max-w-[100px] line-clamp-1 text-ellipsis">{key.replace(/([A-Z])/g, " $1").trim()}</span>
                                      {c[key + "Comment"] && <Tooltip tooltip={c[key + "Comment"]}>
                                        <IoInformationCircle className="text-blue-600 cursor-pointer" />
                                      </Tooltip>}
                                    </span>
                                    <span className="font-bold">{c[key] || 0}/5</span>
                                  </div>
                                );
                              })}
                            </div>
                            {(c.alternateJob) && (
                              <p className="text-xs mt-2">
                                <span className="font-semibold">Suitable for:</span> {c.alternateJob}
                              </p>
                            )}
                            <p className="text-xs mt-1">
                              <span className="font-semibold">Summary:</span> {c.interviewSummary || "No summary provided."}
                            </p>
                          </div>
                        ) : (
                          <div className="text-sm">
                            {c.feedback || "No feedback provided."}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>

            ))}
          </Swiper>
        </div>
      ) : (
        <div className="px-4 font-normal text-left">
          The candidate has not given any interviews yet.
        </div>
      )}
    </div>
  );
};

export default SwipeFeedback